var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "marker-black",
    width: "25px",
    height: "36px",
    viewBox: "0 0 25 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-black-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-black-2",
    transform: "translate(-15.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-black-3",
    transform: "translate(15.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "marker-black-4",
    d: "M12.5,35.2941176 C12.5,35.2941176 25,19.4035594 25,12.5 C25,5.59644063 19.4035594,3.23296945e-13 12.5,3.23296945e-13 C5.59644063,3.23296945e-13 2.48689958e-14,5.59644063 2.48689958e-14,12.5 C2.48689958e-14,19.4035594 12.5,35.2941176 12.5,35.2941176 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "marker-black-5",
    fill: "#FFFFFF",
    cx: 12.5,
    cy: 11.7647059,
    r: 4.41176471
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBlack);
export default __webpack_public_path__ + "static/media/marker-black.06fa880170e91d3eb9762eacfcdcba69.svg";
export { ForwardRef as ReactComponent };